import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"

import RootPage from "composer/pages/RootPage.jsx"
import StageViewerBar from "composer/views/stage/StageViewerBar.jsx"
import CreateStageDialog from "composer/views/stage/CreateStageDialog.jsx"
import EditStageDialog from "composer/views/stage/EditStageDialog.jsx"
import StageListView from "composer/views/stage/StageListView.jsx"
import StageDetailView from "composer/views/stage/StageDetailView.jsx"
import CreateElementDialog from "composer/views/stage/PlaybackElement/CreateElementDialog.jsx"
import EditElementDialog from "composer/views/stage/PlaybackElement/EditElementDialog.jsx"
import StagePicker from "composer/views/StagePicker.jsx"
import FilePicker from "composer/views/FilePicker.jsx"

import {
  Grid,
} from '@material-ui/core';

class StageViewerPage extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      targetStageData: {},
      stageList: [],
      selectedStageID: "",
      selectedStage: null,
      maxHeight: 0,
      filePickerProps: {},
      trashFileIdList: [],
    };
    autoBind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    let boundingRect = this.refs.stageViewerBar.refs.div.getBoundingClientRect();
    let height = window.innerHeight - (boundingRect.y + window.scrollY + boundingRect.height + 10);
    this.setState({
      maxHeight: height,
    });
    this.state.maxHeight = height;
  }

  selectStageById(stage_id) {
    let stage = this.getStageDataById(stage_id);
    this.setState({
      selectedStageID: stage_id,
      selectedStage: stage,
    });
    this.state.selectedStageID = stage_id;
    this.state.selectedStage = stage;

    this.refs.stageDetailView.updateStageDetail(stage_id);
    this.refs.editStageDialog.updateStageDetail();
    if (stage != null) {
      if (this.refs.stageDetailView.refs.stageMediaView) {
        this.refs.stageDetailView.refs.stageMediaView.setState({
          playbackTime: 0,
          playbackDuration: parseInt(stage.duration),
          changeFileConfirmed: false,
        });
      }
    }
    if (this.refs.stageDetailView.refs.stageElementListView) {
      this.refs.stageDetailView.refs.stageElementListView.refs.scrollMenu.state.translate = 0;
    }
  }

  getStageDataById(stage_id) {
    for (let i = 0; i < this.state.stageList.length; i++) {
      let stageData = this.state.stageList[i];
      if (stageData['id'] == stage_id) {
        return stageData;
      }
    }
    return null;
  }

  refresh(stage_id) {
    if (stage_id > 0) {
      this.selectStageById(stage_id);
      this.refs.stageListView.selectStage(stage_id);
    }
    else {
      this.refs.stageDetailView.refresh();
    }

    this.refs.stageListView.refresh();
  }

  refreshOK() {
    if (this.state.targetStageData['id'] != null){
      let previous_stage_id = this.state.targetStageData['id'];
      this.setState({
        targetStageData: this.getStageDataById(previous_stage_id),
      });
    }

    let stage = this.getStageDataById(this.state.selectedStageID);
    if (stage) {
      this.setState({
        selectedStage: stage,
      });
      this.state.selectedStage = stage;
    }

    this.refs.editStageDialog.updateStageDetail();
  }

  handleBackButtonClicked() {
    this.props.root.changeStatus(this.props.root.STATUS_VIEW_LOCALE_LIST());
  }

  createNewStage() {
    if (this.props.root.state.canUpload) {
      this.refs.createStageDialog.setState({
        open: true,
        stageName: "",
        stageType: "photo",
      });
    }
    else {
      this.props.root.showStorageQuotaDialog(this.props.root.emptyFunction);
    }
  }

  editStage() {
    this.refs.editStageDialog.setState({
      open: true,
    })
  }

  addStageElement() {
    if (this.props.root.state.canUpload) {
      this.refs.createElementDialog.setState({
        open: true,
      });
    }
    else {
      this.props.root.showStorageQuotaDialog(this.props.root.emptyFunction);
    }
  }

  editStageElement(element) {
    this.refs.editElementDialog.setState({
      open: true,
      playbackData: element,
      activeTab: 0,
    });
  }

  updateStageSetting() {
    if (this.state.selectedStage != null) {
      let requestObj = {
        stage_id: this.state.selectedStage['id'],
        duration: this.refs.editStageDialog.state.stageMinute * 60 + this.refs.editStageDialog.state.stageSecond,
        allow_enter_next_stage: this.refs.editStageDialog.state.allowNextStage,
        panorama_format: this.refs.editStageDialog.state.panoramaFormat,
      }
      this.props.root.refs.API.request("set_stage_settings", requestObj, this.updateStageSettingOK, this.updateStageSettingFailed);
    }
    if (this.state.selectedStage != null) {
      let requestObj = {
        stage_id: this.state.selectedStage['id'],
        stage_name: this.refs.editStageDialog.state.stageName,
      }
      this.props.root.refs.API.request("update_stage_name", requestObj, this.updateStageNameOK, this.updateStageNameFailed);
    }
  }

  updateStageSettingOK(res) {
    this.props.root.addNotification(Localization.strings.UPDATED)
    this.refs.editStageDialog.handleClose();
    this.refresh();
  }

  updateStageSettingFailed(err) {
    console.log("update stage setting failed");
  }

  updateStageNameOK(res) {

  }

  updateStageNameFailed(err) {
    console.log("update stage name failed");
  }

  reuploadFile() {
    this.refs.filePicker.handleChangeClicked();
  }

  uploadFile() {
    if (this.props.root.state.canUpload) {
      //this.refs.filePicker.chooseFile();
    }
    else {
      this.props.root.showStorageQuotaDialog(this.props.root.emptyFunction);
    }
  }

  onUploadSuccess(resp) {
    if (this.state.trashFileIdList.length > 0) {
      for (let i = 0; i < this.state.trashFileIdList.length; i++) {
        if (this.state.trashFileIdList[i] > -1) {
          this.props.root.refs.API.request("mark_file_as_trash", { file_id: this.state.trashFileIdList[i] });
        }
      }
      this.setState({trashFileIdList : []});
    }

    let requestObj = {
      stage_id: this.refs.stageDetailView.state.stageData['id'],
      file_id: resp['file_id'],
    };
    this.props.root.refs.API.request("set_stage_media_file", requestObj, this.setStageMediaOK, this.setStageMediaFailed);
  }

  setStageMediaOK(res) {
    this.refs.stageDetailView.refs.stageMediaView.setState({ changeFileConfirmed: false });
    this.refresh();
  }

  setStageMediaFailed(err) {
    console.log("set stage media failed");
  }

  onChangeFileConfirm() {
    let movieData = this.refs.stageDetailView.state.stageData['movie_list'][0];
    if (movieData != null) {
      this.setState({trashFileIdList: [movieData['file_id']]});
    }
    this.refs.stageDetailView.refs.stageMediaView.setState({ changeFileConfirmed: true });
  }

  onFileDrop(files) {
    if (this.props.root.state.canUpload) {
      this.refs.filePicker.uploadFile(files);
    }
    else {
      this.props.root.showStorageQuotaDialog(this.props.root.emptyFunction);
    }
  }

  render() {
    let allowedExtension = "";
    if (this.state.selectStage) {
      let type = "";
      if (this.state.selectStage['kind'] == 0){
        type = "video";
      }
      else if (this.state.selectStage['kind'] == 1){
        type = "image";
      }
      allowedExtension = Config.GET_ALLOWED_FILE_EXTENSION(type);
    }
    return (
      <div>
        <CreateStageDialog parent={this} root={this.props.root} ref="createStageDialog"/>
        <EditStageDialog parent={this} root={this.props.root} ref="editStageDialog"/>
        <StageViewerBar parent={this} root={this.props.root} ref="stageViewerBar"/>
        <CreateElementDialog parent={this} root={this.props.root} ref="createElementDialog"/>
        <EditElementDialog parent={this} root={this.props.root} ref="editElementDialog"/>
        <StagePicker parent={this} root={this.props.root} ref="stagePicker"/>
        <FilePicker parent={this} root={this.props.root} ref="filePicker"
          localeId={this.props.localeData['id']}
          allowedExtension={allowedExtension}
          onUploadSuccess={this.onUploadSuccess}
          onChangeFileConfirm={this.onChangeFileConfirm}
        />

        <Grid container>
          <Grid item xs={12} sm={3}>
            <StageListView parent={this} root={this.props.root} ref="stageListView"
              locale_id={this.props.localeData['id']}
            />
          </Grid>
          <Grid item xs={12} sm={9}>
            <StageDetailView parent={this} root={this.props.root} ref="stageDetailView"
              maxHeight={this.state.maxHeight}
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default StageViewerPage;
